import React from 'react';
import interMediumUrl from '@mutiny-pkg/dumpster-ui/theme/fonts/Inter-Medium.ttf';

type MadeWithMutinyWatermarkProps = {
  position: 'fixed' | 'absolute';
};

export function MadeWithMutinyWatermark({ position }: MadeWithMutinyWatermarkProps) {
  return (
    <a
      href="https://www.mutinyhq.com"
      target="_blank"
      rel="noreferrer"
      style={{
        position,
        right: 12,
        bottom: 11,
        zIndex: 2147483647,
        width: 134,
        height: 33,
        display: 'block',
      }}
    >
      <svg
        aria-label="Created in Mutiny"
        role="img"
        viewBox="0 0 134 33"
        xmlns="http://www.w3.org/2000/svg"
        style={{ width: 134, height: 33, display: 'block' }}
      >
        <defs>
          <style>{`
          @font-face {
            font-family: 'Made With Mutiny Inter';
            src: url('${interMediumUrl}') format('truetype');
            font-weight: 500;
          }
        `}</style>
        </defs>
        <rect
          x="1"
          y="1"
          width="132"
          height="31"
          rx="15.5"
          fill="#000000"
          fillOpacity="0.8"
          stroke="#FFFFFF"
          strokeWidth="2"
        />
        <text
          x="14"
          y="20.5"
          fill="#FFFFFF"
          fontFamily="'Made With Mutiny Inter', Inter, sans-serif"
          fontSize="12"
          fontWeight="500"
        >
          Created in
        </text>
        <path
          transform="translate(-1 0)"
          d="M116.252 16.992C116.252 17.9125 116.237 18.5184 116.171 19.1444H116.286C116.402 18.5184 116.564 17.9651 116.877 17.0279L118.643 12.3944H121L117.057 21.1414C116.174 23.2777 115.013 24.248 113.246 24.248C112.902 24.248 112.525 24.1952 112.247 24.1257L112.59 22.0627C112.837 22.1852 113.115 22.2348 113.392 22.2348C114.276 22.2348 114.654 21.5586 114.7 20.724C114.7 20.4625 114.685 20.1843 114.651 19.7705L113.929 12.3944H116.187L116.252 16.992ZM92.3147 17.9477C92.1524 18.9379 92.5112 19.3552 93.1167 19.3553C93.7878 19.3553 94.3937 18.8153 94.5903 17.6197L95.4678 12.4003H97.6775L96.2258 21.1107H94.2468L94.4438 19.5677H94.3779C93.8722 20.5578 93.0355 21.3025 91.9243 21.3025C90.5665 21.3025 89.7331 20.2427 90.0764 18.1264L90.0735 18.1198L91.019 12.3967H93.2419L92.3147 17.9477ZM98.6187 8.01C98.8152 7.9802 99.0211 8.0202 99.1709 8.1228C99.3457 8.242 99.4958 8.4176 99.4771 8.623C99.4614 8.8117 99.4456 9.0136 99.4331 9.1759C99.4175 9.3547 99.6304 9.4938 99.8645 9.4673L103.002 8.7518C103.276 8.6989 103.529 8.8878 103.454 9.0931L103.289 9.5537C103.254 9.6994 103.423 9.8248 103.617 9.7983C104.057 9.732 105.062 9.4244 106.092 9.4542C107.296 9.4873 108.336 9.9675 108.832 10.4311C108.913 10.5073 108.839 10.6364 108.72 10.59C107.918 10.2787 107.284 10.1301 106.345 10.1367C104.956 10.1466 103.164 11.3217 102.299 11.5867C102.046 11.6629 101.765 11.5372 101.74 11.3319C101.728 11.2292 101.728 11.1031 101.734 10.9906C101.74 10.8706 101.608 10.7762 101.455 10.7768L101.313 11.6841L101.02 13.4197L100.187 18.4172C100.09 19.0431 100.334 19.3875 100.758 19.3875C101.086 19.3875 101.329 19.3182 101.592 19.1956L101.279 21.0536C100.905 21.2092 100.38 21.2952 99.8557 21.2952C98.5291 21.2952 97.6644 20.3579 97.9734 18.4999L97.9763 18.5065L98.8098 13.4197L99.2939 11.6841L99.5818 11.2242C98.7614 11.4559 97.9162 11.7123 97.2607 11.865C97.0205 11.9213 96.7769 11.786 96.7766 11.6006V11.2491C96.7765 11.0472 96.5081 10.9083 96.2522 10.9745L93.3123 11.471L93.7612 8.6427L98.6187 8.01ZM111.204 12.1631C112.562 12.1632 113.416 13.0377 113.073 15.1539L112.075 21.1085H109.849L110.829 15.3297C110.991 14.3395 110.632 13.9215 110.027 13.9214C109.356 13.9214 108.75 14.4615 108.553 15.657L107.62 21.1085H105.41L106.893 12.3549L106.902 12.352H108.881L108.706 13.7134H108.772C109.277 12.7231 110.108 12.1631 111.204 12.1631ZM104.265 21.1056H102.055L103.429 12.3981H105.654L104.265 21.1056ZM84.8154 15.1048H84.9685L88.0212 8.2722H90.4873L88.4182 21.0528H86.2642C86.2728 21.0125 87.8282 13.7803 88.0088 12.8126H87.8777L84.9282 19.0528H83.6509L83.3674 12.7929H83.2363C82.9715 13.6291 81.2139 21.023 81.2068 21.0528H79L82.509 8.2722H84.8594L84.8154 15.1048Z"
          fill="#FFFFFF"
        />
      </svg>
    </a>
  );
}
